// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2076) return "static/chunks/common-be0ea829ef8ea7df.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "80b13d619d40c49f" + ".js";
};